<script lang="ts">
    import { fly } from "svelte/transition";
    import { chatVisibilityStore } from "../Stores/ChatStore";
    import { blocker } from "../Utils/screenBlocker";
    import { selectedRoomStore } from "./Stores/SelectRoomStore";
    import Chat from "./Components/Chat.svelte";
    import { hideActionBarStoreBecauseOfChatBar } from "./ChatSidebarWidthStore";
    import { IconX } from "@wa-icons";

    function closeChat() {
        chatVisibilityStore.set(false);
    }

    let isInSpecificDiscussion = $derived($selectedRoomStore !== undefined);

    const sideBarWidth = 288;

    const isRTL: boolean = document.documentElement.dir === "rtl";
</script>

{#if $chatVisibilityStore}
    <section
        id="chat"
        data-testid="nutrivera-people-panel"
        transition:fly={{ duration: 200, x: isRTL ? sideBarWidth : -sideBarWidth }}
        {@attach blocker}
        class="nutrivera-shell-surface chatWindow pointer-events-auto fixed bottom-0 start-12 top-0 z-[304] w-72 border-e border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)]"
    >
        <div data-testid="chat" class="h-full">
            {#if $hideActionBarStoreBecauseOfChatBar && isInSpecificDiscussion}
                <div class="close-window absolute end-2 top-3 rounded-sm p-1 bg-contrast/80 z-50">
                    <button
                        class="hover:bg-white/10 rounded aspect-square w-8 h-8 m-0 flex items-center justify-center !text-white"
                        data-testid="closeChatButton"
                        onclick={closeChat}
                    >
                        <IconX font-size="20" />
                    </button>
                </div>
            {/if}

            <Chat {sideBarWidth} />
        </div>
    </section>
{/if}

<style>
    .chatWindow {
        transition: transform var(--nutrivera-shell-motion);
    }

    @media (max-width: 767px) {
        .chatWindow {
            inset: 0;
            width: min(320px, calc(100dvw - 48px)) !important;
            max-width: calc(100dvw - 48px) !important;
            margin-inline-start: 48px;
        }
    }
</style>
